module.exports = __webpack_public_path__ + "static/media/panic.b2c28be1.mp3";